import React from 'react';

const LOGO_COLOR = '/logo-entricode-transparent.png';
const LOGO_WHITE = '/logo-entricode-white.png';

const SIZES = {
  sm: { h: 28 },
  md: { h: 36 },
  lg: { h: 48 },
  xl: { h: 64 },
};

// For light backgrounds (admin, public, home)
export function Logo({ size = 'md', className = '' }) {
  const { h } = SIZES[size] || SIZES.md;
  return (
    <div className={`flex items-center ${className}`}>
      <img src={LOGO_COLOR} alt="ENTRICODE" style={{ height: `${h}px` }} className="object-contain" draggable={false} />
    </div>
  );
}

// For dark backgrounds (staff pages)
export function LogoWhite({ size = 'md', className = '' }) {
  const { h } = SIZES[size] || SIZES.md;
  return (
    <div className={`flex items-center ${className}`}>
      <img src={LOGO_WHITE} alt="ENTRICODE" style={{ height: `${h}px` }} className="object-contain" draggable={false} />
    </div>
  );
}

export default Logo;
